import axios from "axios";
import router from "@/router";
import { AppOperate } from "@/utils/appfunc";
import { Dialog } from "vant";

const axiosIns = axios.create({});

if (window.API_URL.length > 0) {
  //强制指定接口地址
  axiosIns.defaults.baseURL = window.API_URL;
} else {
  //内部系统按环境区分
  if (process.env.NODE_ENV == "development") {
    axiosIns.defaults.baseURL = "/gateway";
  } else if (process.env.NODE_ENV === "testing") {
    axiosIns.defaults.baseURL = "/gateway";
  } else if (process.env.NODE_ENV == "production") {
    axiosIns.defaults.baseURL = "/gateway";
  }
}

axiosIns.interceptors.request.use(function(config) {
  const XAuthorization = "X-Authorization";
  const jwtToken = "jwtToken";
  let userData = AppOperate.getLoginUserData();
  if (!userData || JSON.stringify(userData) === "{}") {
    delete config.headers[XAuthorization];
    delete config.headers[jwtToken];
  } else {
    config.headers[XAuthorization] = userData.jwtToken;
    config.headers[jwtToken] = userData.jwtToken;
  }
  return config;
});

axiosIns.interceptors.response.use(function(response) {
  console.log("response-----", response);
  let data = response.data;

  if (data.success === true) {
    if (response.config.url.includes("healthInfoAuth")) {
      return Promise.resolve(data);
    } else {
      return Promise.resolve(data.content);
    }
  } else {
    if (
      response.config.url.includes("insuranceAdvancePay") &&
      data.code === "400"
    ) {
    }

    //智能导诊
    let Arrguide = ["disease/getSymptomByBody", "disease/getSymptomByBodyId"];
    if (Arrguide.some(item => response.config.url.indexOf(item) !== -1)) {
      return Promise.resolve(data);
    } else {
      if (data.code === "997") {
        Dialog.confirm({
          title: "提示",
          message: "该账号已在别处登录，请重新登录",
          confirmButtonColor: "#00A795"
        })
          .then(() => {
            // on confirm
            router.goto({ path: "/login" });
          })
          .catch(() => {
            router.goBack();
          });

        localStorage.setItem("isOld", "1");

        localStorage.removeItem("userData");
        return "isOld";
        // if (browser.versions.weChatMiniProgram) {
        //   return wx.miniProgram.postMessage('login')
        // }
      } else if (data.code === "998") {
        console.log("------------走到这里了");
        Dialog.confirm({
          title: "提示",
          message: "登录已过期，请重新登录",
          confirmButtonColor: "#00A795"
        })
          .then(() => {
            // on confirm
            router.goto({ path: "/login" });
          })
          .catch(() => {
            router.goBack();
          });

        localStorage.setItem("isOld", "1");
        localStorage.removeItem("userData");
        return "isOld";
        // if (browser.versions.weChatMiniProgram) {
        //   return wx.miniProgram.postMessage('login')
        // }
        // return router.goto({ path: '/login' })
      } else if (data.code === "990") {
        Dialog.confirm({
          title: "提示",
          message: "请登录后使用",
          confirmButtonColor: "#00A795"
        })
          .then(() => {
            // on confirm
            router.goto({ path: "/login" });
          })
          .catch(() => {
            // if (!!window.HOSPITAL_CODE) {
            //   router.goto({ path: '/hospital/index' })
            // } else {
            //   router.goBack()
            // }
            router.goBack();
          });
        // return router.goto({ path: '/login' })
      } else if (data.code === "relationNotExist") {
        return Promise.reject(data.code);
      } else if (data.code === "hisError") {
        return Promise.reject(data.message); // eslint-disable-line
      } else {
        return Promise.reject(data.message);
      }
    }
    // if (Arrguide.indexOf(disease)) {
    //   console.log('走到这里了111',response)
    // }
  }
});

export default axiosIns;



// WEBPACK FOOTER //
// ./src/utils/axios.js